<template>
  <Panel header="Social" :toggleable="true" :collapsed="true">
    <div class="fontSmall taLeft">
      <div class="p-mb-2">inter-social factors</div>
    </div>
  </Panel>
</template>
